var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.3333C10.3682 12.3333 10.6667 12.0348 10.6667 11.6666L10.6667 2.33329C10.6667 1.96509 10.3682 1.66663 10 1.66663L4.66667 1.66663C4.29847 1.66663 4 1.36816 4 0.99996C4 0.631759 4.29847 0.333293 4.66667 0.333293L10 0.333292C11.1046 0.333292 12 1.22869 12 2.33329L12 11.6666C12 12.7712 11.1046 13.6666 10 13.6666L4.66667 13.6666C4.29847 13.6666 4 13.3681 4 13C4 12.6318 4.29847 12.3333 4.66667 12.3333L10 12.3333ZM3.80473 10.138C3.5444 10.3984 3.12227 10.3984 2.86194 10.138L0.195269 7.47136C-0.065064 7.21103 -0.0650641 6.78889 0.195269 6.52856L2.86193 3.86189C3.12227 3.60156 3.5444 3.60156 3.80473 3.86189C4.06507 4.12223 4.06507 4.54436 3.80473 4.80469L2.27613 6.33329L8 6.33329C8.36819 6.33329 8.66667 6.63176 8.66667 6.99996C8.66667 7.36816 8.36819 7.66663 8 7.66663L2.27613 7.66663L3.80473 9.19522C4.06507 9.45557 4.06507 9.87768 3.80473 10.138Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.7c4901af4b436a1700617cf30dbad70b.svg";
export { ForwardRef as ReactComponent };